import React, { useEffect } from "react";
import { useState } from "react";
import Footer from "../../../MyComponents/Footer";
import GuestNav from "../../../MyComponents/Navbars/GuestNav";
import Hero2 from "../../../MyComponents/Hero2";
import FAQS from "../../../MyComponents/FooterPages/newfaq"
import heroContent from "../HeroContent-GDesign";
import leftimg from "../../../assets/adobeleftimg.png";
import rightimg from "../../../assets/adoberightimg.png";
import CourseTimeline from "../../../MyComponents/CourseTimeline";
import Benefits from "../../../MyComponents/Benefits";
import FunActivities from "../../../MyComponents/FunActivities";
import BenefitsDataImg1 from "../../../assets/BenefitsDataImg1.png";
import BenefitsDataImg2 from "../../../assets/BenefitsDataImg2.png";
import BenefitsDataImg3 from "../../../assets/BenefitsDataImg3.png";
import BenefitsDataImg4 from "../../../assets/BenefitsDataImg4.png";
import BenefitsDataImg5 from "../../../assets/BenefitsDataImg5.png";
import BenefitsDataImg6 from "../../../assets/BenefitsDataImg6.png";
import BenefitsDataImg7 from "../../../assets/BenefitsDataImg7.png";
import BenefitsDataImg8 from "../../../assets/BenefitsDataImg8.png";
import BenefitsDataImg9 from "../../../assets/BenefitsDataImg9.png";
import FunactivitiesImg1 from "../../../assets/graphic-Ui-img.png";
import FunactivitiesImg2 from "../../../assets/graphic-animation-img.png";
import FunactivitiesImg3 from "../../../assets/graphic-shapes-img.png";
import FunactivitiesImg4 from "../../../assets/graphic-logo-img.png";
import FunactivitiesImg5 from "../../../assets/graphic-businessCard-img.png";
import LearningStyle from "../../../MyComponents/LearningStyle"
import VideoSection from "../../../MyComponents/VideoSection";
import Testimonials from "../../../MyComponents/Testimonials";
 const foundationModules = [
    {
      title: "Module 1",
      activities: "11",
      classes: "20",
      description:
        "UI/UX Design Basic Adobe XD- Students will learn the fundamentals of UI/UX design. They will also learn to use assets and components to create animations in Adobe XD.",
    },
    {
      title: "Module 2",
      activities: "6",
      classes: "11",
      description: " Advanced Adobe XD- Students will learn to design websites, mobile apps, logos, and flyers using Adobe XD, building strong practical UI/UX skills.",
    },
  ];

  const benefitsData = [
      {
        title: "Whole Brain Development",
        description: "Activates both brain hemispheres for mental growth.",
        icon: BenefitsDataImg1, //ji
      },
      {
        title: "Enhance Visual & Auditory Skills",
        description: "Sharpens listening and strengthens visual memory.",
        icon: BenefitsDataImg2,
      },
      {
        title: "Enhance Visual & Auditory Skills",
        description: "Improves pattern recognition and logical reasoning.",
        icon: BenefitsDataImg3,
      },
      {
        title: "Proficiency In Math",
        description: "Builds strong mental arithmetic and number fluency.",
        icon: BenefitsDataImg4,
      },
      {
        title: "Develops Speed & Accuracy",
        description: "Trains quick thinking while minimizing mistakes.",
        icon: BenefitsDataImg5,
      },
      {
        title: "Supports Dyslexia & Dyscalculia",
        description:
          "Inclusive, structured techniques that aid special learners.",
        icon: BenefitsDataImg6,
      },
      {
        title: "Personality Development",
        description: "Improves focus, discipline, and personal growth.",
        icon: BenefitsDataImg7,
      },
      {
        title: "Sharpens Cognitive Skills",
        description: "Enhances focus, attention span, and brain agility.",
        icon: BenefitsDataImg8,
      },
      {
        title: "Improves Observation",
        description: "Boosts memory retention and sharpens observation.",
        icon: BenefitsDataImg9,
      },
    ];
    const activitiesData = [
        {
          title: "UI/UX Fundamentals",
          image: FunactivitiesImg1,
        },
        {
          title: "Animations",
          image: FunactivitiesImg2,
        },
        {
          title: "Shapes",
          image: FunactivitiesImg3,
        },
        {
          title: "Logo Designing",
          image: FunactivitiesImg4,
        },
        {
          title: "Business Card",
          image: FunactivitiesImg5,
        },
      ];
     const videoData = {
    title: "Watch Our Introduction Video",
    description:
      "Discover how kids can turn their creativity into stunning designs! In this video, we’ll introduce fun tools, basic design tips, and exciting projects like logos, flyers, and digital art. Whether you're just starting out or love being creative, this is the perfect place to begin your design journey.",

      
    videoSrc: "", // Replace with the actual video URL
  };
const AdobeXD = () => {
  const adobepage = heroContent.Adobesection;
  return (
    <>
       <GuestNav/>
     <Hero2
        titlePart1={adobepage.titlePart1}
        // titlePart2={adobepage.titlePart2}
        description={adobepage.description}
        buttonText={adobepage.buttonText}
        leftImage={leftimg}
        rightImage={rightimg}
      />
       <CourseTimeline
        title="Course Structure and Syllabus"
        modules={foundationModules}
      />
       <Benefits
        title="How Students Can Benefit From Abacus"
        benefitsData={benefitsData}
      />
       <FunActivities
              mainTitle="Learn Adobe XD"
              subTitle="With 40+ Fun Activities"
              activities={activitiesData}
            />
        <LearningStyle/>
         <VideoSection
        title={videoData.title}
        description={videoData.description}
        videoSrc={videoData.videoSrc}
      />
      <Testimonials/>
      <FAQS/>
       <Footer/>
    </>
  )
}
export default AdobeXD